<template>
  <div class="theme--light v-text-field filter-input">
    <div class="v-input__control ">
      <div class="v-input__slot align-center">
        <v-menu
          v-model="showMenu"
          :close-on-content-click="false"
          offset-y
          class="menu"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-chip-group
              style="min-width: 250px;"
              class="flex-grow-1"
              column
            >
              <template v-for="item in selected">
                <v-chip
                  :key="item.name + item.value"
                  :class="{'corner-casess__chip': item.key === 'cornerCases'}"
                  small
                  :close="item.key !== 'cornerCases'"
                  @click:close="remove(item)"
                >
                  <template v-if="item.key === 'cornerCases'">
                    <strong>{{ item.name }}:</strong>&nbsp;
                    <template v-for="cornerValue in item.value">
                      <span :key="item.key + cornerValue">
                        <v-chip
                          small
                          close
                          @click:close="remove(item, cornerValue)"
                        >
                          {{ cornerValue }}
                        </v-chip>
                      </span>
                    </template>
                  </template>
                  <template v-else>
                    <strong>{{ item.name }}:</strong>&nbsp;{{ item.value }}
                  </template>
                </v-chip>
              </template>
            </v-chip-group>
            <div
              role="button"
              @click="() => (selected = [])"
            >
              <v-icon class="icon">
                mdi-close
              </v-icon>
            </div>
            <div
              class="order-3"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon
                class="icon"
                :class="{ active: showMenu }"
              >
                mdi-menu-down
              </v-icon>
            </div>
          </template>
          <v-card
            class="d-inline-flex align-center pa-2"
            style="max-width: 400px"
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  class="pa-1"
                >
                  <v-autocomplete
                    v-model="searchBy"
                    :items="items"
                    label="Search by"
                    item-value="value"
                    item-text="text"
                    clearable
                    single-line
                  />
                </v-col>
                <template v-if="searchByItem.filterType === 'range'">
                  <v-col
                    cols="6"
                    class="pa-1"
                  >
                    <v-text-field
                      v-model="searchFrom"
                      append-icon="mdi-magnify"
                      label="Search from"
                      single-line
                      clearable
                    />
                  </v-col>
                  <v-col
                    cols="6"
                    class="pa-1"
                  >
                    <v-text-field
                      v-model="searchTo"
                      append-icon="mdi-magnify"
                      label="Search to"
                      single-line
                      clearable
                    />
                  </v-col>
                </template>
                <template v-else-if="searchByItem.filterType === 'multiple'">
                  <v-col
                    cols="12"
                    class="pa-1"
                  >
                    <v-select
                      v-model="search"
                      :items="searchByItem.items"
                      :menu-props="{ maxHeight: '200', bottom: true, offsetY: true }"
                      label="Select"
                      multiple
                    />
                  </v-col>
                </template>
                <template v-else-if="searchByItem.filterType === 'checkbox'">
                  <v-col
                    cols="12"
                    class="pa-1"
                  >
                    <v-checkbox
                      v-model="search"
                      :label="searchByItem.text"
                      hide-details
                    />
                  </v-col>
                </template>
                <template v-else-if="searchByItem.filterType === 'date'">
                  <v-col
                    cols="12"
                    class="pa-1"
                  >
                    <v-date-picker
                      v-model="search"
                      :max="$moment().format('YYYY-MM-DD')"
                      width="100%"
                    />
                  </v-col>
                </template>
                <template v-else>
                  <v-col
                    cols="12"
                    class="pa-1"
                  >
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      clearable
                    />
                  </v-col>
                </template>
                <v-col
                  cols="12"
                  class="pa-1"
                >
                  <v-btn
                    dark
                    block
                    color="primary"
                    @click="add"
                  >
                    add
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterInput",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    },
    filterRangeFromPayloadString: {
      type: String,
      default: "From"
    },
    filterRangeToPayloadString: {
      type: String,
      default: "To"
    }
  },
  data() {
    return {
      search: "",
      searchBy: "",
      searchFrom: "",
      searchTo: "",
      showMenu: false
    };
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    searchByItem() {
      return this.items.find(i => i.value === this.searchBy) || {};
    }
  },
  methods: {
    remove(item, value) {
      const newItem = item;
      if (newItem.key === 'cornerCases' && newItem.value.length > 1) {
        const selectedIndex = this.selected.indexOf(newItem)
        const index = newItem.value.indexOf(value);
        if (index > -1) {
          newItem.value.splice(index, 1);
        }
        this.$set(this.selected, selectedIndex, newItem);
      } else {
        this.selected.splice(this.selected.indexOf(newItem), 1);
      }
    },
    addToSelected(key, name, value, validation) {
      if (value !== "") {
        let index = this.selected.findIndex(i => i.key === key);
        index = index >= 0 ? index : this.selected.length;
        this.$set(this.selected, index, {
          value: value,
          name: name,
          key: key,
          validation
        });
      }
    },
    add() {
      let item = Object.assign({}, this.searchByItem);
      let searchFrom = this.searchFrom;
      let searchTo = this.searchTo;
      let search = this.search;
      if (item.filterType === "range") {
        this.addToSelected(
            `${item.value}${this.filterRangeFromPayloadString}`,
            `${item.text} from`,
            searchFrom,
            el => el[item.value] >= searchFrom
        );
        this.addToSelected(
            `${item.value}${this.filterRangeToPayloadString}`,
            `${item.text} to`,
            searchTo,
            el => el[item.value] <= searchTo
        );
      } else {
        this.addToSelected(
            item.value,
            item.text,
            search,
            el => el[item.value] == search
        );
      }

      this.search = "";
      this.showMenu = false;
    }
  }
};
</script>

<style lang="scss">
.icon {
  height: 36px;
}

.icon.active {
  transform: rotate(180deg);
}

.v-input__icon {
  cursor: pointer;
}

.filter-input {
  padding-top: 0;
  margin-left: 15px;
  margin-right: 15px;

  .v-chip {
    margin-top: 2px !important;
    margin-bottom: 2px !important;
    padding-left: 6px;
    padding-right: 4px;
    line-height: 18px;
    font-size: 10px;

    &.v-size--small {
      height: 18px;
    }
  }
}
</style>
